import { AfterViewInit, Component, OnDestroy, ViewChild } from '@angular/core';
import { LeadTaskService } from './lead-task.service';
import { MatStep, MatStepLabel, MatStepper } from '@angular/material/stepper';
import { TranslatePipe } from '@ngx-translate/core';
import { DetailInformationComponent } from './detail-information/detail-information.component';
import { RoomSelectionComponent } from './room-selection/room-selection.component';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { GeneralInformationComponent } from './general-information/general-information.component';
import { MediaQueryService } from '../../services/media-query/media-query.service';
import { Unsubscribable } from 'rxjs';
import { MatStepperService } from './lead-task-services/mat-stepper.service';

@Component({
  selector: 'app-lead-task',
  imports: [
    DetailInformationComponent,
    MatStep,
    MatStepLabel,
    MatStepper,
    RoomSelectionComponent,
    TranslatePipe,
    GeneralInformationComponent,
  ],
  templateUrl: './lead-task.component.html',
  styleUrl: './lead-task.component.scss',
  providers: [
    LeadTaskService,
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: true, displayDefaultIndicatorType: false },
    },
    MatStepperService,
  ],
})
export class LeadTaskComponent implements AfterViewInit, OnDestroy {
  @ViewChild('stepper') stepper: MatStepper | undefined;
  labelStep1 = 'components.lead-task.step-1';
  labelStep2 = 'components.lead-task.step-2';
  labelStep3 = 'components.lead-task.step-3';
  adaptiveStepperLayoutSubscription: Unsubscribable;

  constructor(
    protected matStepperService: MatStepperService,
    protected leadTaskService: LeadTaskService,
    private mediaQueryService: MediaQueryService,
  ) {
    this.adaptiveStepperLayoutSubscription = this.adaptiveStepperLayout();
  }

  adaptiveStepperLayout() {
    return this.mediaQueryService.addListener(
      '(max-width: 600px)',
      (smallWidth: boolean) => {
        if (smallWidth) {
          this.labelStep1 = '';
          this.labelStep2 = '';
          this.labelStep3 = '';
        } else {
          this.labelStep1 = 'components.lead-task.step-1';
          this.labelStep2 = 'components.lead-task.step-2';
          this.labelStep3 = 'components.lead-task.step-3';
        }
      },
    );
  }

  ngAfterViewInit(): void {
    const stepper = this.stepper;
    if (stepper === undefined) {
      throw new Error('leadtask component could not find matstepper');
    }

    this.matStepperService.setMatStepper(stepper);
  }

  ngOnDestroy() {
    this.adaptiveStepperLayoutSubscription.unsubscribe();
  }
}
